import { AppClientPage } from './pages/app-client';
import { AppClientsPage } from './pages/app-clients';
import { AppFabricationJobPage } from './fabrication-jobs/pages/app-fabrication-job';
import { AppFabricationJobsPage } from './fabrication-jobs/pages/app-fabrication-jobs';
import { AppFabricationPurchaseOrderPage } from './fabrication-jobs/pages/app-fabrication-purchase-order';
import { AppFabricationPurchaseOrdersPage } from './fabrication-jobs/pages/app-fabrication-purchase-orders';
import { AppHome } from './pages/app-home';
import { AppLogin } from './pages/app-login';
import { AppNoBranches } from './pages/app-no-branches';
import { AppProjectPage } from './pages/app-project';
import { AppProjectsPage } from './pages/app-projects';
import { AppPurchaseOrderPage } from './pages/app-purchase-order';
import { AppPurchaseOrdersPage } from './pages/app-purchase-orders';
import { AppQuotePage } from './pages/app-quote';
import { AppQuotesPage } from './pages/app-quotes';
import { AppSettings } from './pages/app-settings';
import { AppSupportInbox } from './pages/app-support-inbox';
import { LangAppConfig } from '../../localization/scripts/dealer-franchisee/app-config-lang';
import { MenuItem } from '../../webmodule-common/other/app-index';
import { PageNotFound } from './pages/page-not-found';
import { pages } from './page-constants';
import { resourceClient } from './clients/ui/launcher';
import { resourceFabricationJob } from '../fabrication-jobs/ui/launcher';
import { resourceFabricationPurchaseOrder } from '../fabrication-purchase-orders/ui/launcher';
import { resourceProject } from '../projects/ui/launcher';
import { resourcePurchaseOrder } from '../purchase-orders/ui/launcher';
import { resourceQuote } from '../quotes/ui/launcher';
import { validId } from '../../webmodule-common/other/ui/string-helper-functions';

interface MenuItemSub {
  name: string;
  title: string;
}

export function appConfigMenuPageItems(isFabricatorMode = false) {
  const config = appConfig();
  const getItem = (item: MenuItemSub): MenuItem => {
    return { name: item.name, title: item.title, path: config.routes.find(x => x.name === item.name)?.path ?? '' };
  };
  const pageItems = [
    getItem({
      name: pages.home,
      title: LangAppConfig.dashboard()
    }),
    getItem({
      name: pages.projects,
      title: LangAppConfig.projects()
    }),
    getItem({
      name: pages.quotes,
      title: LangAppConfig.quotes()
    }),
    ...(isFabricatorMode
      ? [
          getItem({
            name: pages.fabricationJobs,
            title: LangAppConfig.fabricationJobs()
          }),
          getItem({
            name: pages.fabricationPurchaseOrders,
            title: LangAppConfig.fabricationPurchaseOrders()
          })
        ]
      : []),
    ...(!isFabricatorMode
      ? [
          getItem({
            name: pages.purchaseOrders,
            title: LangAppConfig.purchaseOrders()
          })
        ]
      : []),
    ...(!isFabricatorMode
      ? [
          getItem({
            name: pages.supportInbox,
            title: LangAppConfig.supportTickets()
          })
        ]
      : []),
    getItem({
      name: pages.clients,
      title: LangAppConfig.clients()
    })
  ];
  pageItems.push({
    name: pages.settings,
    title: LangAppConfig.settings(),
    path: '/settings'
  });
  return pageItems;
}

export function appConfig() {
  return {
    routes: [
      {
        path: '/',
        name: pages.home,
        component: 'app-home',
        action: async () => {
          //return home
          return new AppHome(); // await import("./pages/app-home");
        }
      },
      {
        path: '/login',
        name: pages.login,
        component: 'app-login',
        action: async () => {
          return new AppLogin();
        }
      },
      {
        path: '/no-branches',
        name: pages.noBranches,
        component: 'app-no-branches',
        action: async () => {
          return new AppNoBranches();
        }
      },
      {
        path: '/clients',
        name: pages.clients,

        action: async () => {
          return new AppClientsPage();
        }
      },
      {
        path: '/clients/:id',
        name: pages.client,

        action: async () => {
          return new AppClientPage();
        },
        resolveUrl: {
          type: resourceClient,
          resolver: id => (validId(id) ? `/clients/${id}` : '/clients')
        }
      },
      {
        path: '/settings',
        name: pages.settings,
        action: async () => {
          return new AppSettings();
        }
      },
      {
        path: '/quotes',
        name: pages.quotes,
        action: async () => {
          return new AppQuotesPage();
        }
      },
      {
        path: '/quotes/:id',
        name: pages.quote,
        action: async () => {
          return new AppQuotePage();
        },
        resolveUrl: {
          type: resourceQuote,
          resolver: id => (validId(id) ? `/quotes/${id}` : '/quotes')
        }
      },
      {
        path: '/projects',
        name: pages.projects,
        component: 'app-projects',
        action: async () => {
          return new AppProjectsPage();
        }
      },
      {
        path: '/projects/:id',
        name: pages.project,
        action: async () => {
          return new AppProjectPage();
        },
        resolveUrl: {
          type: resourceProject,
          resolver: id => (validId(id) ? `/projects/${id}` : '/projects')
        }
      },
      {
        path: '/fabrication-jobs',
        name: pages.fabricationJobs,
        action: async () => {
          return new AppFabricationJobsPage();
        }
      },
      {
        path: '/fabrication-jobs/:id',
        name: pages.fabricationJob,
        action: async () => {
          return new AppFabricationJobPage();
        },
        resolveUrl: {
          type: resourceFabricationJob,
          resolver: id => (validId(id) ? `/fabrication-jobs/${id}` : '/fabrication-jobs')
        }
      },
      {
        path: '/fabrication-purchase-orders',
        name: pages.fabricationPurchaseOrders,
        action: async () => {
          return new AppFabricationPurchaseOrdersPage();
        }
      },
      {
        path: '/fabrication-purchase-orders/:id',
        name: pages.fabricationPurchaseOrder,
        action: async () => {
          return new AppFabricationPurchaseOrderPage();
        },
        resolveUrl: {
          type: resourceFabricationPurchaseOrder,
          resolver: id => (validId(id) ? `/fabrication-purchase-orders/${id}` : '/fabrication-purchase-orders')
        }
      },
      {
        path: '/purchase-orders/:id',
        name: pages.purchaseOrder,

        action: async () => {
          return new AppPurchaseOrderPage();
        },
        resolveUrl: {
          type: resourcePurchaseOrder,
          resolver: id => (validId(id) ? `/purchase-orders/${id}` : '/purchase-orders')
        }
      },
      {
        path: '/purchase-orders',
        name: pages.purchaseOrders,

        action: async () => {
          return new AppPurchaseOrdersPage();
        }
      },
      {
        path: '/support-inbox',
        name: pages.supportInbox,

        action: async () => {
          return new AppSupportInbox();
        }
      },
      {
        path: '(.*)',
        name: 'not-found',
        action: async () => {
          return new PageNotFound();
        }
      }
    ]
  };
}
